import { cn } from "@/lib/chillnn/cn";
import { KidsCosleepingPolicyType } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { FormItem } from "@/components/ui/form/_base/form";
import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";
import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";
import { SelectField } from "@/components/ui/form/fields/select-field";

import { useKidsCosleepingPolicyOfHotelPolicy } from "./hooks/use-kids-cosleepling-policy/use-kids-cosleepling-policy";
import { QuestionSectionWrapper } from "../../../../../../../../../_shared/ui/components/system/question/_layouts/item-wrapper";

const isActiveOptions = [
	{
		id: "kidsCosleepingPolicy-isActive#1",
		label: "添い寝を認めない",
		value: "false",
	},
	{
		id: "kidsCosleepingPolicy-isActive#2",
		label: "添い寝のキッズポリシーを設定する",
		value: "true",
	},
];

export const QuestionHotelPolicyKidsCosleepingPolicy = () => {
	const {
		kidsCosleepingPolicy,
		isEdited,
		hasError,
		isActiveBoolean,
		isActiveString,
		onUpdateIsActive: handleIsActiveChange,
		discountTypeOptions,
		handleDiscountTypeSelect,
		maxAgeOptions,
		handleMaxAgeChange,
		ratioOptions,
		handleRatioSelect,
		handleStaticAmountChange,
	} = useKidsCosleepingPolicyOfHotelPolicy();

	const kidsDiscountType = kidsCosleepingPolicy?.kidsDiscountType?.value;

	const showRatio = kidsDiscountType === KidsCosleepingPolicyType.Ratio;
	const showStatic = kidsDiscountType === KidsCosleepingPolicyType.Static;

	const guide = `添い寝の子どもは、子どもの定員ではカウントされますが、部屋の定員にはカウントされません。<br />
料金計算単純化のため、定額料金での設定を推奨しております。`;

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"添い寝の設定"}
			guide={guide}
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<FormItem>
					<div className="flex flex-col gap-y-6">
						<RadioGroupField
							value={isActiveString}
							options={isActiveOptions}
							handleValueChange={handleIsActiveChange}
							errorMessage={kidsCosleepingPolicy?.isActive?.error}
						/>
						<div
							className={cn(
								"flex flex-col gap-y-8 rounded border border-zinc-200 px-4 py-12",
								!isActiveBoolean && "visually-hidden",
							)}
						>
							<div className="flex flex-col gap-y-4">
								<label>年齢設定</label>
								<QuestionSectionWrapper>
									<p className="">0歳から</p>
									<SelectField
										value={kidsCosleepingPolicy?.kidsMaxAge?.value}
										options={maxAgeOptions}
										handleValueChange={handleMaxAgeChange}
										placeholder="選択"
										errorMessage={kidsCosleepingPolicy?.kidsMaxAge?.error}
									/>

									<p>歳以下までの添い寝の選択が可能</p>
								</QuestionSectionWrapper>
							</div>

							<div className="flex flex-col gap-y-4">
								<label>料金設定</label>
								<QuestionSectionWrapper>
									<div className="flex flex-col gap-y-6">
										<QuestionSectionWrapper>
											<p className="text-sm">子どもの料金は</p>
											<SelectField
												value={kidsDiscountType}
												options={discountTypeOptions}
												handleValueChange={handleDiscountTypeSelect}
												placeholder="選択"
												errorMessage={kidsCosleepingPolicy?.kidsDiscountType?.error}
											/>
										</QuestionSectionWrapper>

										{showRatio && (
											<QuestionSectionWrapper>
												<p>大人の</p>
												<SelectField
													value={kidsCosleepingPolicy?.ratio?.value}
													options={ratioOptions}
													handleValueChange={handleRatioSelect}
													placeholder="選択"
													errorMessage={kidsCosleepingPolicy?.ratio?.error}
												/>
												<p>の料金</p>
											</QuestionSectionWrapper>
										)}

										{showStatic && (
											<QuestionSectionWrapper>
												<p className="text-sm">子ども１人あたり</p>
												<InputNumberField
													value={kidsCosleepingPolicy?.static?.amount?.value}
													handleInput={handleStaticAmountChange}
													errorMessage={kidsCosleepingPolicy?.static?.amount?.error}
												/>
												<p>円（税込）</p>
											</QuestionSectionWrapper>
										)}
									</div>
								</QuestionSectionWrapper>
							</div>
						</div>
					</div>
				</FormItem>
			}
		/>
	);
};

QuestionHotelPolicyKidsCosleepingPolicy.displayName = "QuestionHotelPolicyKidsCosleepingPolicy";
